const m = "wms/abnormalInventory";
export const id = {
    id: "WAREHOUSE_MANAGEMENT_INVENTORY_ABNORMAL",
    method: "POST",
    name: "库存异常",
    type: "menu",
    apiName: "getInventoryAbnormalList",
    url: `${m}/abnormallist`
};

export const children = {
    ADD_DATA: {
        id: "WAREHOUSE_MANAGEMENT_INVENTORY_ABNORMAL_ADD_DATA",
        apiName: "addInventoryAbnormal",
        method: "POST",
        name: "添加异常",
        type: "view",
        url: `${m}/save`
    },
    EDIT_DATA: {
        id: "WAREHOUSE_MANAGEMENT_INVENTORY_ABNORMAL_EDIT_DATA",
        apiName: "editInventoryAbnormal",
        method: "POST",
        name: "处理异常",
        type: "view",
        url: `${m}/update`
    },
    LOOK_MORE: {
        id: "WAREHOUSE_MANAGEMENT_INVENTORY_ABNORMAL_LOOK_MORE",
        name: "查看",
        type: "view"
    },
    DEL_DATA: {
        id: "WAREHOUSE_MANAGEMENT_INVENTORY_ABNORMAL_DEL_DATA",
        apiName: "deleteInventoryAbnormal",
        method: "POST",
        name: "删除",
        type: "view",
        url: `${m}/deleteAbnormal`
    },
    MATERIAL_ADD: {
        id: "WAREHOUSE_MANAGEMENT_INVENTORY_ABNORMAL_MATERIAL_ADD",
        name: "物料选择",
        type: "element"
    },
    MATERIAL_DEAL: {
        id: "WAREHOUSE_MANAGEMENT_INVENTORY_ABNORMAL_MATERIAL_DEAL",
        name: "物料处理",
        type: "element"
    },
    MATERIAL_DELETE: {
        id: "WAREHOUSE_MANAGEMENT_INVENTORY_ABNORMAL_MATERIAL_DELETE",
        name: "物料批量删除",
        type: "element"
    }
};
